// extracted by mini-css-extract-plugin
module.exports = {"root":"Category_root__2RCMc","label":"Category_label__1HjeU","content":"Category_content__1DbHh","header":"Category_header__39hBr","location":"Category_location__2c1hd"};